import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import Text from '@jetbrains/ring-ui/components/text/text'
import * as React from 'react'

import styles from './TitleRow.css'

type Props = {
  name?: string | null | undefined
  hasChildren?: boolean | null | undefined
  level?: number | null | undefined
}

function TitleRow({name, level, hasChildren}: Props) {
  let title

  switch (level) {
    case 0:
      title = <h2 className={styles.title1}>{name}</h2>
      break

    case 1:
      title = <h3 className={styles.title2}>{name}</h3>
      break

    case 2:
      title = <h4 className={styles.title2}>{name}</h4>
      break

    default:
      title = <h5 className={styles.title2}>{name}</h5>
      break
  }

  return (
    <Row>
      <Col className={styles.col} xs={12}>
        {title}
        {hasChildren === false && <Text info>{'No different values in this group'}</Text>}
      </Col>
    </Row>
  )
}

export default TitleRow
